import { getScrollTop, setBannerHeight, stickyHeader } from './helpers';

import injectRegistrationScripts, { injectDefaultScripts } from './registrationScripts';

import toggleCookieBanner from './cookie-banner';
import { getCookieValue } from './cookie';
/* Hero Fader ------------------------------------------------------------*/

function fade() {
  const heroHeight = document.querySelector('.hero').clientHeight;
  const winPosition = getScrollTop();
  const winPositionPercent = (winPosition / heroHeight);
  const fadeValue = (0 + winPositionPercent / 2.5);
  const fader = document.getElementById('fader');
  if (fader) {
    fader.style.opacity = fadeValue;
  }
}

function toggleMegaMenu() {
  const header = document.querySelector('header');
  const navLinks = document.querySelectorAll('.header__nav__left .nav-link');
  const navLinksBtns = document.querySelectorAll('.header__nav__left .accessible-btn');
  const MegaNavMenu = document.querySelectorAll('.header__nav__left .mega-menu .wrapper');

  function resetBorderColors() {
    navLinks.forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.style.borderColor = 'transparent';
    });
  }

  function hideVisibleMegaMenu() {
    const targetContent = document.querySelector('.mega-menu.visible');
    if (targetContent) targetContent.classList.remove('visible');
  }

  function toggleAria(btnElement, megaMenuElement, isExpanded, isHidden) {
    if (btnElement) btnElement.setAttribute('aria-expanded', isExpanded);
    if (megaMenuElement) megaMenuElement.setAttribute('aria-hidden', isHidden);
  }

  function showMegaMenu(currentNavLink, btnElement, megaMenuElement) {
    resetBorderColors();
    // eslint-disable-next-line no-param-reassign
    currentNavLink.style.borderColor = '#2dccd2';

    setTimeout(() => {
      header.classList.add('mega-menu-pop-up');
      document.body.classList.add('mega-menu-overlay');
    }, 200);

    hideVisibleMegaMenu();
    currentNavLink.parentElement.querySelector('.mega-menu').classList.add('visible');
    toggleAria(btnElement, megaMenuElement, true, false);
  }

  function hideMegaMenu(btnElement, megaMenuElement) {
    resetBorderColors();

    setTimeout(() => {
      header.classList.remove('mega-menu-pop-up');
      document.body.classList.remove('mega-menu-overlay');
    }, 200);

    hideVisibleMegaMenu();
    toggleAria(btnElement, megaMenuElement, false, true);
  }

  function handleNavLinkEvent(navLink, i) {
    const currentNavLink = navLink;

    navLink.addEventListener('mouseover', () => {
      showMegaMenu(currentNavLink, navLinksBtns[i]);
    });

    navLinksBtns[i].addEventListener('click', () => {
      const targetContent = currentNavLink.parentElement.querySelector('.mega-menu');

      if (targetContent.classList.contains('visible')) {
        hideMegaMenu(navLinksBtns[i], MegaNavMenu[i]);
      } else {
        showMegaMenu(currentNavLink, navLinksBtns[i], MegaNavMenu[i]);
      }
    });
  }

  navLinks.forEach(handleNavLinkEvent);

  header.addEventListener('mouseleave', () => {
    resetBorderColors();
    navLinksBtns.forEach((btn) => {
      hideMegaMenu(btn);
    });
  });

  document.addEventListener('focusout', (event) => {
    const headerGroup = header.contains(event.relatedTarget);
    if (!headerGroup) {
      resetBorderColors();
      navLinksBtns.forEach((btn) => {
        hideMegaMenu(btn);
      });
    }
  });
}


/* Pop-up menu */
function toggleMobileMenu() {
  document.querySelector('header .burger-menu').addEventListener('click', () => {
    document.querySelector('header').classList.toggle('menu-pop-up');
    if (document.querySelector('header').classList.contains('menu-pop-up')) {
      document.body.classList.add('overflow-hidden');
    } else { document.body.classList.remove('overflow-hidden'); }
  });
}


function animateLogo() {
  const logo = document.querySelector('.logo');
  if (logo) {
    setTimeout(() => {
      logo.classList.remove('logo-animate');
    }, 2000);
  }
}

function accordionHandler() {
  const accordion = document.querySelectorAll('.js-accordion');
  if (accordion) {
    accordion.forEach((accordionEl) => {
      const accordionToggle = accordionEl.querySelectorAll('.js-accordion-toggle');
      accordionToggle.forEach((el) => {
        el.addEventListener('click', () => {
          const targetItem = el.parentElement;
          const targetParent = targetItem.parentElement;
          const targetContent = targetItem.querySelector('.js-accordion-content');

          if (el) el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') === 'false' ? 'true' : 'false');
          if (targetContent) targetContent.setAttribute('aria-hidden', targetContent.getAttribute('aria-hidden') === 'false' ? 'true' : 'false');

          const targetContentParent = targetContent.parentElement;
          const targetContentDesc = targetContentParent.parentElement;
          if (targetItem.classList.contains('open')) {
            targetItem.classList.remove('open');
            targetContent.style.maxHeight = null;
          } else {
            const accordionOpen = targetParent.querySelector('li.open');
            if (accordionOpen) {
              accordionOpen.classList.remove('open');
              accordionOpen.querySelector('.js-accordion-content').style.maxHeight = null;
            }
            targetItem.classList.add('open');
            targetContent.style.maxHeight = `${targetContent.scrollHeight}px`;
            if (targetContentDesc.classList.contains('js-accordion-content')) {
              targetContentDesc.style.maxHeight = '900px';
            }
          }
        });
      });
    });
  }
}

function moveChatWidget() {
  const main = document.querySelector('main');
  if (window.pageYOffset >= document.documentElement.offsetHeight - 60) {
    main.classList.add('dock-chatwidget');
  } else if (document.querySelector('main.dock-chatwidget')) main.classList.remove('dock-chatwidget');
}

function injectOnView() {
  const pageWithHeroForm = ['/lp/services/call-answering-service-ILP', '/lp/services/telephone-answering-service-ILP', '/lp/services/virtual-receptionist-ILP', '/lp/services/small-business-answering-ILP', '/lp/services/phone-answering-service-ILP', '/lp/services/after-hours-answering-service-ILP', '/services/call-center-solution'];
  if (
    pageWithHeroForm.includes(window.location.pathname)
  ) {
    injectRegistrationScripts();
  }
  if (window.pageYOffset >= 300) {
    injectRegistrationScripts();
    injectDefaultScripts();
  }
}

injectOnView();

window.addEventListener('load', () => {
  setBannerHeight();
  stickyHeader();
  animateLogo();
  accordionHandler();
  toggleCookieBanner();

  if (getCookieValue('isregistered') && document.getElementById('paid-ad-registration')) {
    document.getElementById('paid-ad-registration').classList.add('is-registered');
  }

  if (window.innerWidth > 1120) toggleMegaMenu();
  else toggleMobileMenu();

  if (window.innerWidth > 580) moveChatWidget();
});

window.addEventListener('scroll', () => {
  stickyHeader();
  injectOnView();

  if (document.querySelector('.hero')) fade();

  if (window.innerWidth > 580) setTimeout(moveChatWidget, 100);
});

window.addEventListener('resize', () => {
  setBannerHeight();
  stickyHeader();
  if (window.innerWidth > 1024) {
    document.querySelector('header').classList.remove('menu-pop-up');
    document.body.classList.remove('overflow-hidden');
  }

  if (window.innerWidth > 580) setTimeout(moveChatWidget, 100);
});


window.addEventListener('pageshow', (event) => {
  if (getCookieValue('isregistered') && event.persisted) {
    document.getElementById('paid-ad-registration').classList.add('is-registered');
    document.getElementById('paid-ad-registration').classList.remove('loading');
  }
});
